import { $httpProvider } from '../providers';

function getAdresseApiDataGouv(adresse) {
  return $httpProvider()({
    method: 'GET',
    url: 'https://api-adresse.data.gouv.fr/search/',
    params: {
      q: adresse,
      limit: 1
    }
  }).then(r => r.data.features).catch(function() { return []; });
}

export default {
  getAdresseApiDataGouv
};



// WEBPACK FOOTER //
// ./src/repositories/apiadressedatagouv.repository.js